import { useSelector } from "react-redux";

import SwiperCore, { Navigation } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import { IRootState } from "../../..";

// Import Swiper styles
import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/autoplay";

// import required modules
import { FreeMode, Autoplay } from "swiper";
import { useNavigate } from "react-router-dom";
SwiperCore.use([Navigation]);

const Banners = () => {
  const navigate = useNavigate();
  const home = useSelector((state: IRootState) => state.home.value);

  return (
    <div>
      <div className="container mx-auto p-5 py-7  gap-4 text-black">
        <Swiper
          freeMode={true}
          autoplay={{ delay: 3000 }}
          modules={[FreeMode, Autoplay]}
          className="mySwiper"
          breakpoints={{
            0: {
              slidesPerView: 1.1,
              spaceBetween: 10,
            },
            768: {
              slidesPerView: 3,
              spaceBetween: 15,
            },
          }}
        >
          <div className="">
            {home.home.banners.map((banner, index) => (
              <SwiperSlide key={index}>
                <div
                  className="h-[150px] bg-primary/20 flex items-center justify-center bg-center bg-cover bg-no-repeat"
                  style={{ backgroundImage: `url(${banner.image})` }}
                  onClick={
                    () => {}
                    // navigate(
                    //   `/${banner.restaurant.establishment_type}/${banner.restaurant.slug}`
                    // )
                  }
                ></div>
              </SwiperSlide>
            ))}
          </div>
        </Swiper>
      </div>
    </div>
  );
};

export default Banners;
